export default __webpack_public_path__ + "f3d0ac66c1a19f9c80aced5d81874684.png";